const storeActions = ['default', 'add', 'remove'] as const;
export type StoreAction = typeof storeActions[number];
export function isStoreAction(x: string): x is StoreAction {
  return storeActions.includes(x as StoreAction);
}
// https://stackoverflow.com/questions/51528780/typescript-check-typeof-against-custom-type
